import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import AnthologyPageNavView from "scripts/views/anthologyPageNavView";
import BaseMediaDetailsPageView from "scripts/views/baseMediaDetailsPageView";
import templateAnthologyPage from "templates/anthologyPage.hbs";

const chan = Backbone.Radio.channel;

class AnthologyPageView extends BaseMediaDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
  ) {
    super(options, breadcrumbService, connectionService, securityService);

    this.model.on(
      "change:presentationType",
      this.onPresentationTypeChangeSaveUserPreference,
      this,
    );

    chan("controllerView").reply("anthologyPageView", this.replyPageView, this);
  }

  get template() {
    return templateAnthologyPage;
  }

  createNavView() {
    return new AnthologyPageNavView({
      model: this.model,
      anthologyModel: this.mediaModel,
    });
  }

  render() {
    super.render();

    this.renderFavoriteButton();
    this.renderCurationButton();
    this.renderPageHeaderDescriptionContainer();

    chan("tracking").trigger("anthology:open", {
      mediaId: this.mediaModel.get("id"),
    });

    return this;
  }

  getBreadcrumbText() {
    return this.mediaModel.get("name");
  }

  getDocumentTitle() {
    return `${this.mediaModel.get("name")}`;
  }
}

export default AnthologyPageView;
